import { Injectable } from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {AuthenticationService} from './authentication.service';
import {catchError} from 'rxjs/operators';

/**
 * Interceptor para manejar los errores de autenticación
 */
@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {

  /**
   * Constructor
   * @ignore
   */
  constructor(private authenticationService: AuthenticationService) { }

  /**
   * Método que se ejecuta al interceptar una petición
   * @param request
   * @param next
   * @returns
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(err => {
      if ([401, 403].includes(err.status)) {
        this.authenticationService.deleteSecurityTokenInfo();
      }
      // const error = (err && err.error && err.error.message) || err.statusText;
      return throwError(err);
    }));
  }
}
